<template>
  <div class="collab-wrap">
    <div class="collab-list-wrap">
      <div class="add-contact-wrap" v-if="showAddContact">
        <div class="add-contact-content" @click="handleAddContact">
          <div class="add-contact small"> + </div>
          <div class="add-contact-text">{{$t('collab.add')}}</div>
        </div>
      </div>
      <div class="title-line" v-if="showFileManagerList">
        {{$t('base.fileManager')}}({{file_managers.length}})
      </div>
      <div class="collab-item-wrap" v-if="showFileManagerList" style="margin: 0 0 10px 0;">
        <div class="collab-item" v-for="(item, index) in file_managers" :key="index"  @click="handleCollabItemClick(item)">
          <avatar
            class="thumb-icon collab-item-avatar"
            :user="{
              profile_pic_key: item.profile_pic_key,
              id: item.id,
              full_name_pinyin: item.full_name_pinyin,
              name_first_letter: item.name_first_letter,
              name: item.name
            }"
            :isActive="item.isActive"
            :size="36"
          />
          <div class="collab-item-info">
            <div class="account-details">
              <span class="account-status-name ellipsis">{{item.name}}</span>
              <span v-if="!item.is_active" class="account-status-activte">({{$t('card.not.activated')}})</span>
              <span v-if="item.current_user && !item.is_group" class="account-status-mine">({{$t('base.me')}})</span>
            </div>
            <div class="account-level">{{collabRoleStatus(item.final_role)}}</div>
          </div>
        </div>
      </div>
      <div class="title-line">
        {{$t('base.staff')}}({{collabList.length}})
      </div>
      <div class="collab-item-wrap" style="flex: 1;">
        <div class="collab-item" v-for="(item, index) in collabList" :key="index"  @click="handleCollabItemClick(item)">
          <avatar
            class="thumb-icon collab-item-avatar"
            :user="{
              profile_pic_key: item.user.profile_pic_key,
              id: item.user.id,
              full_name_pinyin: item.user.full_name_pinyin,
              name_first_letter: item.user.name_first_letter,
              name: item.user.name
            }"
            :isActive="item.isActive"
            :type="item.user.is_group && (item.user.is_department && 'department' || 'group')"
            :size="36"
          />
          <div class="collab-item-info">
            <div class="account-details">
              <span class="account-status-name ellipsis">{{item.user.name}}</span>
              <span v-if="item.is_group && item.user.user_count" class="account-status-count">({{item.user.user_count + $t('unit.person')}})</span>
              <span v-if="!item.user.is_active && !item.is_group" class="account-status-activte">({{$t('card.not.activated')}})</span>
              <span v-if="!item.accepted" class="account-status-activte">{{$t('collab.notAcceptedYet')}}</span>
              <span v-if="item.current_user && item.is_group" class="account-status-mine">({{$t('collab.includingMe')}})</span>
              <span v-if="item.current_user && !item.is_group" class="account-status-mine">({{$t('base.me')}})</span>
            </div>
            <div class="account-level">
              <span>{{collabRoleStatus(item.final_role)}}</span>
              <span v-if="!item.direct_role" class="tag" v-html="$t('collab.inheritRole')"></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-popup
      class="collab-roles-detail-popup"
      v-model="showDetailPopup"
      position="right"
      :lazy-render="false"
      :overlay="false"
    >
      <collab-roles-detail :headerItem="headerItem" :collabItem="collabItem" @remove-role="handleRemoveRole" />
    </van-popup>
    <collab-level :collabItem="collabItem" :headerItem="headerItem" />
  </div>
</template>

<script>
import {i18n} from '@/utils/i18n'
import ajax from '@/utils/ajax'
import Avatar from '../utils/Avatar'
import CollabRolesDetail from '../collab/CollabRolesDetail'
import CollabLevel from '../collab/CollabLevel'
import ContactSelect from '../contact/ContactSelect'
import {toast} from '@/utils/common'
import {COLLAB_INFO_ON_ITEM, GET_FILE_MANAGER_LIST} from '@/config/api'
import config from '@/config'

export default {
  i18n,
  name: 'FileCollabs',
  data () {
    return {
      collabList: [], // 协作list
      collabItem: {}, // 点击当前协作成员item 的信息
      file_managers: [], // 文件管理员list
      roleMessage: {
        owner: 'roles.owner',
        coowner: 'roles.coowner',
        editor: 'roles.editor',
        online_collaborator: 'roles.online_collaborator',
        viewer_uploader: 'roles.viewer_uploader',
        viewer: 'roles.viewer',
        previewer_uploader: 'roles.previewer_uploader',
        previewer: 'roles.previewer',
        uploader: 'roles.uploader'
      },
      showDetailPopup: false,
      isFileManagerFetching: false,
      fetchedDeptId: 0
    }
  },
  props: {
    headerItem: Object,
    showTabs: Boolean
  },
  components: {
    Avatar,
    CollabRolesDetail,
    CollabLevel,
    ContactSelect
  },
  watch: {
    $route (to, from) {
      if (to.query.tab === 'collab') {
        this.showDetailPopup = !!to.query.collabRolesDetail
      }
    },
    // 监听refreshCollabList字段 刷新协作列表, refreshCollabList参数为一个时间戳（只是为了保证每次都刷新，无其他意思）
    'store.collabState.refreshCollabList' () {
      this.getCollabListInfo()
    },
    showTabs () {
      const folderId = this.$route.params.id

      if (this.showTabs && (folderId !== this.folderId)) this.getCollabListInfo()
    }
  },
  methods: {
    handleRolesDetail (show) {
      this.showDetailPopup = show
    },
    handleAddContact () {
      this.setState({actionSheet: {
        actionFrom: 'collab',
        title: i18n.t('collab.inviteMember'),
        actionName: 'collab',
        actions: [
          {
            leftIcon: 'invite-company',
            name: i18n.t('base.staff'),
            callback: () => {
              const {actionsheet, ...rest} = this.$route.query

              this.$router.replace({ query: {...rest, invite: 1} })
            }
          }
        ]
      }})
    },
    handleRemoveRole (type) {
      let toastMessage
      // 弹出不同的toast
      if (type === 'roles') {
        toastMessage = 'collab.roles.removed'
      } else if (type === 'group') {
        toastMessage = 'collab.group.removed'
      } else {
        toastMessage = 'collab.department.removed'
      }
      toast.success(i18n.t(toastMessage))
    },
    handleCollabItemClick (collabItem) {
      this.collabItem = collabItem
      this.setState({collabState: {...this.store.collabState, currentRoleLevel: collabItem.final_role}})
      this.toggleQuery('collabRolesDetail')
    },
    collabRoleStatus (item) {
      return i18n.t(this.roleMessage[item])
    },
    getCollabListInfo () {
      // 如果开启了 文件管理员权限，获取文件管理员列表
      if (config.viewConfig.isFileManagerEnabled) {
        const {space, department_id} = this.headerItem

        if (space !== 'external_space' && department_id && department_id !== 0 &&
            department_id !== this.fetchedDeptId && !this.isFileManagerFetching) {
          this.isFileManagerFetching = true
          ajax({
            url: `${GET_FILE_MANAGER_LIST}?_=${new Date().getTime()}&department_id=${department_id}`
          }).then(res => {
            this.fetchedDeptId = department_id
            const {id} = config.user_info || {}
            if (res && res.success) {
              // GET_FILE_MANAGER_LIST 与 COLLAB_INFO_ON_ITEM 数据结构不同
              // 为了展示详情页，填充一些必须的固定字段
              res.file_managers.map(item => {
                item.final_role = 'coowner'
                item.accepted = true
                if (id === item.id) {
                  item.current_user = true
                  item.user = config.user_info
                } else {
                  item.current_user = false
                  item.user = {
                    id: item.id,
                    profile_pic_key: item.profile_pic_key,
                    full_name_pinyin: item.full_name_pinyin,
                    name_first_letter: item.name_first_letter,
                    name: item.name
                  }
                }
              })
              this.file_managers = res.file_managers
            } else {
              this.file_managers = []
            }
            this.isFileManagerFetching = false
          })
        }
      }

      // 获取协作成员列表
      const {id} = this.$route.params
      const url = `${COLLAB_INFO_ON_ITEM}?_=${new Date().getTime()}&folder_id=${id}`

      ajax({url}).then(({accepted_collabs = [], unaccepted_collabs = [], final_role}) => {
        const collabList = [...accepted_collabs, ...unaccepted_collabs]

        // 当前账号的权限取 COLLAB_INFO_ON_ITEM 接口最外层的final_role （为计算后的权限）
        // 如果有未接受的则取未接受的
        collabList.forEach(item => {
          if (item.current_user && !item.is_group) {
            item.final_role = !item.accepted ? item.unaccepted_role : final_role
          }
        })
        this.collabList = collabList
        this.$emit('collabList-callback', collabList)
      })
    }
  },
  computed: {
    showAddContact () {
      const {permissions = [], final_role, is_external_collab_folder} = this.headerItem

      // 只有以下三种情况才可以邀请且开了可以邀请的权限
      return ['owner', 'coowner', 'editor'].includes(final_role) && permissions.includes('item_create_collab') && !is_external_collab_folder
    },
    showFileManagerList () {
      return this.file_managers.length > 0
    }
  },
  created () {
    // 将获取协作列表方法塞入 store， 方便邀请协作是获取
    this.setState({
      collabState: {
        ...this.store.collabState,
        roleMessage: this.roleMessage
      }
    })
    const {module} = this.$route.params
    const {scenario} = this.$route.query
    // 如果是分享不请求接口
    if ((module !== 'share') && (scenario !== 'share')) this.getCollabListInfo()

    let roles = {}
    if ([13, 25, 1, 23, 14, 27].includes(config.enterprise_info.plan_id)) {
      roles = {
        owner: 'roles.owner',
        coowner: 'roles.coowner',
        editor: 'roles.editor',
        viewer_uploader: 'roles.viewer_uploader',
        viewer: 'roles.viewer',
        previewer_uploader: 'roles.previewer_uploader',
        previewer: 'roles.previewer',
        uploader: 'roles.uploader'
      }
      this.setState({
        collabState: {
          ...this.store.collabState,
          roleMessage: roles
        }
      })
    }
  }
}
</script>

<style lang="postcss">
@import 'variables';

.collab-wrap {
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #eeeff5;
  overflow: auto;

  & .collab-list-wrap {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    background-color: #eeeff5;

    & .add-contact.small {
      font-size: 30px!important;
    }

    & .add-contact-wrap {
      width: 100%;
      display: flex;
      align-items: center;
      background-color: #eeeff5;

      & .add-contact-content {
        display: flex;
        align-items: center;
        flex: 1;
        height: 56px;
        margin: 10px 0;
        background-color: #fff;

        & .add-contact,
        & .remove-contact {
          box-sizing: border-box;
          font-size: 40px;
          width: 36px;
          height: 36px;
          line-height: 36px;
          border-radius: 36px;
          border: 1px dashed #d1d4df;
          text-align: center;
          color: var(--contentIcon);
          margin-left: 15px;

          & span {
            font-size: 16px;
          }
        }

        & .add-contact-text {
          margin-left: 10px;
        }
      }
    }

    & .invite-popup {
      height: 100%;
    }

    & .title-line {
      height: 35px;
      border-bottom: 1px solid #e5e7e9;
      font-size: 12px;
      line-height: 35px;
      color: #848484;
      padding-left: 15px;
      background-color: #fff;
    }

    & .collab-item-wrap {
      display: flex;
      flex-direction: column;
      background-color: #fff;
      overflow: auto;

      & .collab-item {
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 15px;
        flex: 0 0 auto;
        background-color: #fff;

        & .collab-item-avatar {
          flex: 0 0 auto;
        }

        & .collab-item-info {
          display: flex;
          flex: 1;
          flex-direction: column;
          border-bottom: 1px solid #e5e7e9;
          padding: 10px 10px 10px 0;
          margin-left: 10px;
          overflow: hidden;

          & .account-details {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            display: flex;

            & span {
              flex: 0 0 auto;
            }

            & span.account-status-name {
              flex: 0 1 auto;
              margin-right: 5px;
            }

            & .account-status-count {
              color: #848484;
            }

            & .account-status-activte {
              color: #ff5555;
            }

            & .account-status-mine {
              color: #6ca2ff;
            }
          }

          & .account-level {
            font-size: 12px;
            line-height: 17px;
            height: 17px;
            color: #848484;

            & .tag {
              display: inline-block;
              box-sizing: border-box;
              padding: 0 6px;
              margin-right: 6px;
              border-radius: 2px;
              border: 1px solid #d1d4e0;
              color: #b2b7ca;
            }
          }
        }
      }
    }
  }

  & .collab-roles-detail-popup {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    z-index: 2!important;
  }
}
</style>
